import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/installationspartner-caseimg.jpg';

export default {
  path: '/cases/installationspartner',
  color: variables.installationspartner,
  casebg,
  title: 'Installationspartner',
  headline: 'iOS & Android application',
  description: 'A true digitalization journey',
  isWeb: false,
  isAndroid: false,
};
